import { ArgumentError } from '../utils/errors';

import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

/**
 * Category.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Zone extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true },
            name: {},
            parent: {},
            translations: {},
            preview_picture: { readOnly: true },
            location_picture: { readOnly: true }
        };
    }

    seatCount(zones = null) {
        // If zones is provided, aggregate seatCount by counting children values
        let childrenSeatCount = 0;
        if (zones) {
            let childZones = zones.filter(zone => zone.parent === this.pk);
            childrenSeatCount = childZones.reduce((acc, zone) => (acc += zone.seatCount(zones)), 0);
        }
        return this.seat_count + childrenSeatCount;
    }

    generalAdmissionCount(zones = null) {
        // If zones is provided, aggregate generalAdmissionCount by counting children values
        let childrenGeneralAdmissionCount = 0;
        if (zones) {
            let childZones = zones.filter(zone => zone.parent === this.pk);
            childrenGeneralAdmissionCount = childZones.reduce((acc, zone) => (acc += zone.generalAdmissionCount(zones)), 0);
        }
        return (this.general_admission ? this.general_admission.capacity : 0) + childrenGeneralAdmissionCount;
    }

    categories(inventory) {
        if (!this.inventories[inventory]) {
            return [];
        }
        return this.inventories[inventory].categories;
    }

    getUsageInfo(params) {
        params.id = this.pk;
        let path = `${this.constructor.getItemUrl(params)}/usage_info`;
        return fetcher.get(path).then(({ response }) => response);
    }

    static sortByName = zones => {
        zones.sort((zoneA, ZoneB) => {
            if (zoneA.name < ZoneB.name) return -1;
            if (zoneA.name > ZoneB.name) return 1;
            return 0;
        });
        return zones;
    };

    static listUrl({ organizationId, chartId }) {
        if (!organizationId || !chartId) {
            throw new ArgumentError(`[Model][Zone][getAll] organizationId and chartId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/charts/${chartId}/zones`;
    }
}
